module.exports = __webpack_public_path__ + "img/eventBanner.1002d06d.png";